import ApiGateway from "./api-gateway";
import {getBaseURL} from "./base-urls";

const baseUrl = getBaseURL();
console.log("baseUrl", baseUrl);
const ApiGatewayInstance = new ApiGateway(baseUrl);

export async function getRequest(path) {
    return await ApiGatewayInstance.axiosClient.get(path);
}

export async function postRequest(path, data) {
    return await ApiGatewayInstance.axiosClient.post(path, data);
}


// WEBPACK FOOTER //
// ./src/network/base/api-server.js